module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/setting-08e2052db4a0ec3bc9b2b2d5d2fcf5e0.svg&quot;;"